import { InvisibleButton } from '@/widgets/components/invisible-button';
import styled from 'styled-components';

export const BaseFlex = styled.div`
  display: flex;
`;

const Flex = styled.div`
  display: flex;
  color: #ffffff;
`;

export const SearchInputWrapper = styled(Flex)`
  width: 880px;
  margin-top: 73px;
  padding-bottom: 12.5px;
  border-bottom-color: white;
  border-bottom-style: solid;
  border-bottom-width: 2px;
`;

export const SearchButton = styled(InvisibleButton)`
  padding: 0;
  margin: 0;
  width: 40px;
  height: 40px;
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' aria-hidden='true' focusable='false' width='1em' height='1em' style='-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);' preserveAspectRatio='xMidYMid meet' viewBox='0 0 1024 1024'%3E%3Cpath d='M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1c-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z' fill='%23ffffff'/%3E%3C/svg%3E");
`;

export const StyledInput = styled.input`
  height: 100%;
  border-radius: 0px;
  border: none;
  padding: 0px;
  margin: 0px 0px 0px 12px;

  color: #ffffff;
  font-size: 20px;
  background-color: black;
  flex-grow: 1;
  outline: none;

  ::placeholder {
    color: #ffffff;
    font-size: 18px;
  }
`;

export const SearchResultsWrapper = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  margin-top: 48px;
  margin-bottom: 50px;
  width: 880px;
  height: 100%;
  overflow-y: auto;
  font-size: 18px;
`;

export const SearchResultsTitle = styled.div`
  width: 100%;

  :after {
    content: 'PROPERTIES';
    font-size: 18px;
    font-weight: bold;
    line-height: 1.5;
  }
`;

export const Address = styled.div`
  width: 350px;
  white-space: pre;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Spacer = styled.div`
  width: ${(props) => props.width || '50px'};
`;

export const Column = styled.div`
  width: ${(props) => props.width || '100px'};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ListingIds = styled.div`
  width: 150px;
`;

export const SearchResultsHeaderWrapper = styled(Flex)`
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
`;

export const SearchResultItemWrapper = styled(Flex)`
  cursor: pointer;
  line-height: 1;
  margin-top: 18px;

  &:hover > div {
    font-weight: bold;
    color: #37a3bc;
  }
`;
